import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../hooks/useQueryParams";

export function GroupFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/customer-groups/groups-with-tasks/`
  );

  return (
    <Picker
      label={t("Group")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.customer_group_id?.split(",") || []}
      onSelectionChange={(keys) =>
        setParam("customer_group_id", Array.from(keys))
      }
      // TODO: Use data instead of data?.results when endpoint no longer returns paginated results (CP-1265)
      items={data?.results}
      testID="group-filter-picker"
    />
  );
}
